export default {
  styleOverrides: {
    root: {
      '&&': {
        background: 'transparent',
      },
    },
  },
};
